import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupRemoveMemberContentProps } from './msg-group-remove-member-content';
import { MsgGroupRemoveMemberContent } from './msg-group-remove-member-content';

export interface MsgGroupRemoveMemberProps extends MsgGroupRemoveMemberContentProps {}

export const MsgGroupRemoveMember = memo(function MsgGroupRemoveMember({
  message,
}: MsgGroupRemoveMemberProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupRemoveMemberContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
